var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _path20, _path21, _path22, _path23, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaitingForBroker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 313,
    viewBox: "0 0 396 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.265 30.638c-2.554 1.062-5.174 2.425-6.578 4.814-1.486 2.524-1.308 5.658-1.031 8.578 2.41 25.326 8.763 52.261-2.206 75.202-5.325 11.13-14.23 20.049-21.314 30.156-7.083 10.108-12.431 22.727-9.143 34.618C5.01 198.535 20 206.59 30.103 217.771c6.612 7.311 11.249 16.194 17.42 23.884 6.17 7.691 14.625 14.466 24.475 14.918 14.167.654 25.694-11.609 39.584-14.45 14.23-2.908 28.56 4.493 40.098 13.352 11.538 8.86 22.033 19.593 35.477 25.125 14.847 6.113 31.583 5.178 47.213 8.851 14.23 3.348 27.33 10.468 41.457 14.264 14.128 3.796 30.686 3.566 41.632-6.13 14.265-12.679 13.143-35.263 22.254-52.035 8.463-15.583 25.03-24.886 36.181-38.663 20.064-24.795 19.408-62.693 2.371-89.66-17.036-26.966-47.896-43.295-79.452-47.546-14.23-1.914-28.883-1.652-42.564-6.007-36.62-11.648-58.412-53.386-95.798-62.071-23.764-5.511-46.877 4.033-67.12 15.781-17.57 10.199-33.78 5.65-52.066 13.254z",
    fill: "#466EC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M336.742 119.321v-.403L204.163 17.095a.487.487 0 00-.578 0L71 118.918v157.83h.253V277H337V119.17l-.258.151z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M335.161 276.909H73V121.074L204.08 20.326l131.081 100.748v155.835z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M325.727 267.673H82.434v-144.62L204.08 29.557l121.647 93.496v144.62z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.35 27.396L96.941 66.286l49.484 188.666 148.408-38.889L245.35 27.396z",
    fill: "#466EC4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M281.537 56.059H128.113V251.1h153.424V56.059z",
    fill: "#F5F5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M74.241 121.322l131.081 77.918-131.08 77.918V121.322z",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.248 121.322l131.081 77.918-131.081 77.918V121.322z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M334.416 121.322l-131.08 77.918 131.08 77.918V121.322z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M335.41 121.322L204.329 199.24l131.081 77.918V121.322z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M73.248 274.676l131.081-102.237 131.08 102.237H73.248z",
    fill: "#000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.248 277.156L204.329 174.92l131.08 102.236H73.248z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M198.619 70.992h-61.568v4.963h61.568v-4.963zm71.498 17.852H137.051v4.963h133.066v-4.963zm0 12.902H137.051v4.963h133.066v-4.963z",
    fill: "#466EC4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M270.117 114.65H137.051v4.963h133.066v-4.963zm0 12.905H137.051v4.963h133.066v-4.963z",
    fill: "#466EC4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M213.018 140.457h-75.967v4.963h75.967v-4.963zm27.805 12.904H137.051v4.963h103.772v-4.963z",
    fill: "#466EC4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M326.401 309.515c26.966 0 48.827-21.826 48.827-48.749 0-26.923-21.861-48.748-48.827-48.748-26.967 0-48.828 21.825-48.828 48.748s21.861 48.749 48.828 48.749z",
    fill: "url(#paint1_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M326.401 308.707c26.52 0 48.018-21.463 48.018-47.94 0-26.477-21.498-47.941-48.018-47.941s-48.018 21.464-48.018 47.941c0 26.477 21.498 47.94 48.018 47.94z",
    fill: "#174593"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M326.4 298.876c21.082 0 38.172-17.062 38.172-38.11 0-21.047-17.09-38.11-38.172-38.11-21.081 0-38.171 17.063-38.171 38.11 0 21.048 17.09 38.11 38.171 38.11z",
    fill: "#DDE1EC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.479 229.389h-2.158v33.666h2.158v-33.666z",
    fill: "#535461"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M359.177 259.959h-30.484v2.693h30.484v-2.693zm-52.006-10.075l-1.251 2.386 19.18 10.028 1.252-2.386-19.181-10.028z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M326.4 265.346a4.043 4.043 0 004.046-4.04 4.042 4.042 0 00-4.046-4.04 4.042 4.042 0 00-4.046 4.04 4.043 4.043 0 004.046 4.04z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M359.177 259.42h-30.484v2.693h30.484v-2.693zm-32.816-.046l-19.18-10.028-1.252 2.386 19.181 10.028 1.251-2.386z",
    fill: "#535461"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M326.401 264.806a4.042 4.042 0 004.046-4.039 4.042 4.042 0 00-4.046-4.04 4.043 4.043 0 00-4.047 4.04 4.043 4.043 0 004.047 4.039z",
    fill: "#535461"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M291.194 265.345c0-21.048 17.09-38.11 38.172-38.11a38.16 38.16 0 0117.049 4.003 38.09 38.09 0 0113.456 11.192c-6.496-11.785-19.04-19.774-33.473-19.774-21.082 0-38.171 17.062-38.171 38.11a37.901 37.901 0 007.67 22.915 37.894 37.894 0 01-4.703-18.336zm54.642 7.143s-.284.57-.674 1.254a16.8 16.8 0 01-1.724-1.059l-.119-.083-.063-.046.674-.743 1.906.677zm-4.437.737a1.934 1.934 0 00-.419.582 36.188 36.188 0 01-2.334-1.18l-.028-.015a3.73 3.73 0 01.625-.618s2.65.8 2.156 1.231z",
    fill: "#000"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M346.643 233.317a3.275 3.275 0 01-3.151 1.231c-.034-.689-.177-1.377-.552-1.798-.986-1.107 3.204-.922 3.204-.922.128.508.295 1.006.499 1.489zm6.664 5.808c-.453.167-2.208.874-2.402 1.885-.121-.45-.211-.908-.27-1.37l2.158-1.169c.205.19.378.41.514.654zm-13.386.086c-.168.481-.362.953-.58 1.414-.083-.609-.427-2.166-1.788-2.668.269-.368.458-.59.458-.59l1.91 1.844zm9.488 15.19s-2.8-.222-5.23-.328l-.244-.01a63.216 63.216 0 00-.996-.033c-2.358-.056-5.025-.879-5.478-1.023.17-.263.354-.517.55-.761l3.697.808s.583.186 1.878.758l-2.124-1.566 6.474 1.169s.225-.028 1.416.637l.057.349zm-7.717-23.92c.495 0 .884-.524 1.379-.497.256.013.476.176.688.323.8.553 1.69.963 2.631 1.212.366.097.753.17 1.12.081.367-.089.711-.377.753-.753a1.287 1.287 0 00-.065-.489 6.047 6.047 0 00-2.636-3.473c-.512-.314-1.138-.553-1.706-.357-.513.177-.843.656-1.214 1.051-.28.295-.597.552-.944.765-.27.163-.675.269-.83.568-.292.557.168 1.563.824 1.569z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 169468,
    y1: 192560,
    x2: 169468,
    y2: 53265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 326.401,
    y1: 309.515,
    x2: 326.401,
    y2: 212.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingForBroker);
export default __webpack_public_path__ + "static/media/waitingForBroker.7df9f0b5fd552213db4a37229a4ce72a.svg";
export { ForwardRef as ReactComponent };